// extracted by mini-css-extract-plugin
module.exports = {"button":"ButtonEmpty_button__34HZI"};